import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Calculators from '../components/Calculators';
import FeaturedBook from '../components/FeaturedBook';
import BookReading from '../components/BookReading';
import Testimonials from '../components/Testimonials';
import Footer, { Contact } from '../components/Footer';

const Home = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Calculators />
      <BookReading />
      <FeaturedBook />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
